import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import {
	Container,
	Divider,
	Grid,
	Link,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
	useTheme
} from '@material-ui/core'
import {Link as RoutrLink}  from 'react-router-dom'

interface FooterProps {
    useThemeHook?: any;
}

export default function Footer({useThemeHook = useTheme}: FooterProps) {
	const theme = useThemeHook()
	const spacing: number = theme.spacing()
	const currentYear = new Date().getFullYear()
	return (
		<footer>
			<Divider style={{marginTop: `${spacing * 6}px`, marginBottom: `${spacing * 4}px`}}
				orientation="horizontal"/>
			<Container maxWidth="md">
				<Grid
					className={'footer-grid'}
					container
					spacing={2}
					direction="row"
					justifyContent="flex-start"
					alignItems="flex-start"
				>
					<Grid item xs>
						<Paper className={'footer-logo-holder'}>
							<img style={{height: '32px'}} src={'./logo.png'} alt={'logo'}/>
						</Paper>
					</Grid>
					<Grid item xs>
						<Typography variant="h2">
                            Kontakt
						</Typography>
						<List dense={false}>
							<ListItem>
								<ListItemText
									primary="Graniczna 8A"
									secondary="33-100 Tarnów"
								/>
							</ListItem>
							<ListItem>
                                Email: <Link href={'mailto:integra@tarnow.net.pl'}
									color="inherit">integra@tarnow.net.pl</Link>
							</ListItem>
							<ListItem>
                                Tel.: <Link href={'tel:(14) 624 38 07'} color="inherit">(14) 624 38 07</Link>
							</ListItem>
						</List>
					</Grid>
					<Grid item xs>
						<Typography variant="h2">
                            Zobacz
						</Typography>
						<List dense={false}>
							<ListItem>
								<Link href="http://tarnow.net.pl/" target={'_blank'} color="inherit">
									{'Tarnow.net.pl'}
								</Link>
							</ListItem>
							<ListItem>
								<Link href="https://pasaz.net.pl/" target={'_blank'} color="inherit">
									{'Pasaz.net.pl'}
								</Link>
							</ListItem>
							<ListItem>
								<Link href="http://integra.tarnow.net.pl/" target={'_blank'} color="inherit">
									{'Integra'}
								</Link>
							</ListItem>
							<ListItem>
								<RoutrLink to={'/agreement'} style={{color:'inherit', textDecoration: 'none'}}>
									{'Regulamin'}
								</RoutrLink>
							</ListItem>
						</List>
					</Grid>
				</Grid>
				<Grid container style={{paddingTop: `${spacing * 6}px`, paddingBottom: `${spacing * 4}px`}}>
					<Grid item>
						<Typography variant={'body1'}>
                            © 2003 - {currentYear} Tarnow.net.pl
						</Typography>
					</Grid>
				</Grid>
			</Container>
		</footer>
	)
}